mutation CreatePasswordReset($address: String!, $baseUrl: String!) {
  createPasswordReset(address: $address, baseUrl: $baseUrl) {
    error
  }
}
